import { oz } from '@weft/utils';
import { ApiDateSchema, ObjectIdSchema } from '../../primitives';
import { segregated } from '../../utils';
import { EventDataSchema } from './event-data-schema';

export const IngestedEventSchema = oz.object({
  timestamp: ApiDateSchema,
  customerAlias: oz.string().min(1),
  accountId: ObjectIdSchema,
  data: EventDataSchema.optional().nullable(),
  ref: oz.string(),
  name: oz.string(),
});
  
export type IngestedEvent = oz.infer<typeof IngestedEventSchema>;

export const DBIngestedEventSchema = IngestedEventSchema.extend({
  day: oz.number(),
  month: oz.number(),
  year: oz.number(),
}).openapi('DBIngestedEvent');

export type DBIngestedEvent = oz.infer<typeof DBIngestedEventSchema>;

export const CreatedIngestedEventSchema = segregated(DBIngestedEventSchema);
export type CreatedIngestedEvent = oz.infer<typeof CreatedIngestedEventSchema>;
  
export const IngestedMatchedEventSchema = IngestedEventSchema
  .omit({ accountId: true })
  .extend({
    data: EventDataSchema.nullable().optional(),
    customerId: oz.string().optional().nullable(),
    affectedMeters: oz.number().optional(),
  }).openapi('IngestedMatchedEvent');

export type IngestedMatchedEvent = oz.infer<typeof IngestedMatchedEventSchema>;

export const IngestedEventSampleSchema = IngestedMatchedEventSchema
  .extend({
    customerName: oz.string().optional(),
  }).openapi('IngestedEventSample');

export type IngestedEventSample = oz.infer<typeof IngestedEventSampleSchema>;

export const S3IngestedEventSchema = IngestedEventSchema.omit({ accountId: true });
export type S3IngestedEvent = oz.infer<typeof S3IngestedEventSchema>;